import { Routes } from "@angular/router";
import { authGuard } from "./core/gaurds/auth.guard";
import { NewIntakeComponent } from "./features/intakeForm/components/new-intake/new-intake.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "patients",
    pathMatch: "full",
  },
  {
    path: "login",
    loadComponent: () =>
      import("./features/auth/login/login.component").then(
        (c) => c.LoginComponent
      ),
  },
  {
    path: "patients",
    data: { breadcrumb: "Patients" },
    loadChildren: () =>
      import("./features/patients/patients.routes").then(
        (r) => r.PATIENTS_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: "new-intake/:id",
    component: NewIntakeComponent,
    title: 'Patient Intake',
    data: { breadcrumb: "Patient Form" },
    canActivate: [authGuard],
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
